import React from "react";
import "./Terms.css";
import logo from "../../../assets/images/logo.png";
import { FaAngleLeft } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";

function Termsofuse() {
  const style = { color: "white", fontSize: "15px" };
  const navigate = useNavigate();
  const location = useLocation();

  const handleBackClick = () => {
    const from = location.state?.from || "/register";
    const formData = location.state?.formData || {};
    navigate(from, { state: { formData } });
  };

  return (
    <div className="body-terms">
      <div id="return-button">
        <FaAngleLeft style={style} />
        <a onClick={handleBackClick} style={{ cursor: "pointer" }}>
          Kthehu
        </a>
      </div>
      <div className="content">
        <div className="body-header">
          <h1>Brieffo</h1>
          <p>Kushtet e përdorimit</p>
        </div>
        <div className="text">
          <div>
            <h1>Pranimi i Kushteve</h1>
            <p>
              Duke përdorur Brieffo (App), ju pranoni të jeni të lidhur nga këto
              Kushte të Përdorimit. Nëse nuk pranoni këto Kushte, ju lutemi
              shmangni përdorimin e App.
            </p>
          </div>
          <br />
          <div>
            <h1>Përdorimi i App</h1>
            <p>
              <strong>Krijimi i Llogarisë:</strong> Për të pasur qasje në disa
              funksione të Aplikacionit, mund të kërkohet të krijoni një
              llogari. Ju jeni përgjegjës për mbajtjen e konfidencialitetit të
              informacionit të llogarisë tuaj dhe pranoni të na njoftoni
              menjëherë për çdo përdorim të paautorizuar.
              <br />
              <strong>Sjellja e Përdoruesit:</strong> Ju pranoni të mos përdorni
              Aplikacionin për ndonjë qëllim të paligjshëm ose në shkelje të
              ligjeve në fuqi. Ju gjithashtu pranoni të mos: a. Postoni ose
              transmetoni ndonjë përmbajtje që është e paligjshme, e dëmshme,
              kërcënuese, abuzive, ose ndryshe e papranueshme (kjo është
              specifike për krijimin e reklamave). b. Përpiqeni të fitoni qasje
              të paautorizuar në ndonjë pjesë të App.
            </p>
          </div>
          <br />
          <div>
            <h1>Pronësia Intelektuale</h1>
            <p>
              <strong>Pronësia:</strong> Aplikacioni dhe përmbajtja origjinale,
              funksionet dhe veçoritë e tij janë pronë e Brieffo dhe mbrohen nga
              ligjet ndërkombëtare të të drejtave të autorit, markës tregtare,
              patentës, sekreteve tregtare dhe të tjera.
              <br />
              <strong>Licenca:</strong> Brieffo ju jep një licencë të kufizuar,
              jo-ekskluzive, të revokueshme për të përdorur App për qëllime
              personale dhe jo-komerciale, dhe gjithashtu nëse dëshironi të
              promovoni diçka përmes reklamave nëse jeni pronar biznesi.
            </p>
          </div>
          <br />
          <div>
            <h1>Ogranizimi i Përgjegjësisë</h1>
            <p>
              <strong>Përjashtim:</strong> Aplikacioni ofrohet ashtu si është,
              pa asnjë garanci, shprehëse ose të nënkuptuar. Brieffo nuk jep
              asnjë deklaratë ose garanci në lidhje me saktësinë ose plotësinë e
              përmbajtjes së Aplikacion.
              <br />
              <strong>Ogranizimi i Përgjegjësisë:</strong> Brieffo dhe
              bashkëpunëtorët e tij nuk do të jenë të përgjegjshëm për ndonjë
              dëm direkt, indirekt, aksidental, special ose pasues që lind nga
              përdorimi i Aplikacionit.
            </p>
          </div>
          <br />
          <div>
            <h1>Ndërprerja</h1>
            <p>
              Brieffo rezervon të drejtën të ndërpresë ose pezulloni qasjen tuaj
              në App, pa paralajmërim, nëse shkelni ndonjë nga këto Kushte.
            </p>
          </div>
          <br />
          <div>
            <h1>Ndryshimet e Kushteve</h1>
            <p>
              Brieffo rezervon të drejtën të përditësojë këto Kushte të
              Përdorimit në çdo kohë. Ju do të njoftoheni për çdo ndryshim duke
              postuar Kushtet e Përdorimit të rinj në këtë faqe.
            </p>
          </div>
          <div>
            <br />
            <h1>Na Kontaktoni</h1>
            <p>
              Nëse keni ndonjë pyetje ose shqetësim në lidhje me këto Kushte të
              Përdorimit, ju lutemi kontaktoni në{" "}
              <a href="mailto:onlinekosova@gmail.com">onlinekosova@gmail.com</a>
            </p>
          </div>
          <br />
          <div>Faleminderit!</div>
        </div>
        <div className="updated-text">
          <p>Përditësimi i fundit: 15.11.2023</p>
        </div>
      </div>
    </div>
  );
}

export default Termsofuse;
